import React, {useState, useEffect, useRef} from "react";
import { Bars } from "react-loader-spinner";
import GenericTemplate from "../../templates/GenericTemplate";
import {
  apollo_useStyles,
  apollo_useRowStyles,
  valueToOption,
  valueToOptionNull,
  option_setpoint_attribute_type,
  option_setpoint_cv_category,
  option_setpoint_action_category,
} from "../../atom/Apollo_styles";
import {herasetpointedit_path, herasetpointdetail_path, hera_setpoints_path} from "../../atom/Apollo_links";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, ApolloUserProfileAuth} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";
import Tooltip from '@material-ui/core/Tooltip';
import Fab from "@material-ui/core/Fab";
import AddIcon from '@material-ui/icons/Add';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import {ApolloContext} from "../../atom/Apollo_Context";
import axios from "axios";
import {ApolloMessage, CustomizedSnackbars} from "../../atom/Apollo_Mesasge";
import {SetPoint, SetPointActiveUpdateRequest} from "./HeraModel"
import {Link, useHistory} from "react-router-dom";
import Card from "@material-ui/core/Card/Card";
import {createMuiTheme} from "@material-ui/core/styles";
import {MUIDataTableColumnDef, MUISortOptions, SelectableRows} from "mui-datatables";
import { ApolloDataTable, STORAGE_KEY } from "../../atom/Apollo_DataTable";
import { options_state_setpoint } from "./common/CommonConst";
import { ApiResponse, ApolloAxios, getResultType, isSuccessApi } from "../../atom/Apollo_ApiRequest3";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Backdrop from "@material-ui/core/Backdrop";
import { ApolloEventRecord, ItemList, LogData } from "../../atom/Apollo_EventRecord";
import moment from "moment";
import ActiveDialog from "./common/ActiveDialog";

// エラーメッセージ
const ERROR_MESSAGE = [
  "データ取得に失敗しました",
];
// 警告メッセージ
const WARNING_MESSAGE = [
  "有効可能上限数を超えてしまうため、ステータスを「有効」にすることができません。他の有効な測定ポイントのステータスを「無効」にしてから、再度設定してください。",
]

const HeraSetPointsPage: React.FC = () => {
  const classes = apollo_useStyles();

  const [setPoints, setSetPoints] = useState<SetPoint[]>([])
  const history = useHistory();
  const {state} = React.useContext(ApolloContext);
  const trackerId = state.current.trackerId
  const [updateListCnt, setUpdateListCnt] = useState<number>(0)

  const {data, setmsg} = React.useContext(ApolloMessage);
  const [progress, setProgress] = useState(false);
  const [open, setOpen] = React.useState(false);
  const selectRow = useRef<SetPoint | null>(null);
  const newActive = useRef(false);

  useEffect(() => {
    // トラッカーIDが設定されていない場合の処理
    if (!trackerId) {
      return setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "トラッカーIDが設定されていません。広告主アカウント詳細画面からトラッカーIDを発行して下さい。"
        }
      });
      return;
    }

    setProgress(true);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })
    const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_setpoints_path}/${trackerId}`
    const fetchData = async () => {
      await axios.get(
        url,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.accesstoken}`,
          }
        }
      ).then(result => {
        if (result.data.resultcode === 0) {
          setSetPoints(result.data.result);
        } else {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: ERROR_MESSAGE[0]
            }
          });
        }
      }).catch(err => {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: ERROR_MESSAGE[0]
          }
        });
      })
        .finally(() => {
          setmsg({
            type: "loading",
            payload: {
              ...data,
              loading: false
            }
          })
          setProgress(false);
        });
    };
    fetchData();
  }, [updateListCnt]);

  const handleChangeStatus = async (checked: boolean, row: SetPoint) => {
    selectRow.current = row;
    newActive.current = checked

    if (row.isActive && !checked) {
      setOpen(true);
    } else {
      await handleChangeStatusExecute();
    }
  };

  const handleChangeStatusExecute = async () => {
    setProgress(true);
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })
    let isSuccess = false;

    let itemList: ItemList[] = [
      {
        key: "ステータス",
        beforeValue: valueToOption(selectRow.current?.isActive, options_state_setpoint).label,
        afterValue: valueToOption(newActive.current, options_state_setpoint).label,
      },
    ]

    // 実行時ログ
    const executionLog: LogData = {
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken ,
      accountGroupID : state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID : state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "測定ポイント一覧画面",
      category: "測定ポイント",
      actionType: "更新",
      targetID: selectRow.current?.ID + "",
      targetName: selectRow.current?.name + "",
      itemList: itemList,
    }
    ApolloEventRecord(executionLog);

    const url = `${hera_setpoints_path}/${trackerId}/${selectRow.current?.ID}/active`
    const apiBody: SetPointActiveUpdateRequest = {
      isActive: newActive.current,
    }

    await ApolloAxios.patch(url, apiBody).then(response => {
      const res: ApiResponse = response.data
      if (!isSuccessApi(res.resultCode)) {
        const type: string = response?.data?.message === "有効可能上限数エラー" ? "warning" : getResultType(res.resultCode)
        const message: string = response?.data?.message === "有効可能上限数エラー" ? WARNING_MESSAGE[0] : `ステータス更新に失敗しました。${res?.message ?? ""}`
        return Promise.reject({
          open: true,
          type: type,
          errmsg: message,
        });
      }
      isSuccess = true;
      setUpdateListCnt(updateListCnt + 1);
    }).catch(err => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: err.type,
          message: err.errmsg,
        }
      });
    }).finally(() => {
      const resultLog: LogData = {
        ...executionLog,
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "result",
        result: isSuccess? "成功" : "失敗",
      }
      ApolloEventRecord(resultLog);
    });

    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: false
      }
    })
    setProgress(false);
  }

  const theme = createMuiTheme({});
  const columns: MUIDataTableColumnDef[] = [
    {
      name: "ID",
      label: "測定ポイントID",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "name",
      label: "測定ポイント名",
      options: {
        filter: true,
        sort: false,
      }
    },
    {
      name: "isActive",
      label: "ステータス",
      options: {
        filter: true,
        sort: false,
        filterOptions: {
          renderValue: (value: any) => valueToOption(value, options_state_setpoint).label
        },
        customFilterListOptions: {
          render: (value: any) => valueToOption(value, options_state_setpoint).label
        },
        customBodyRenderLite: (idx: number) => {
          const row: SetPoint = setPoints[idx]
          const isActive = row.isActive
          return (
            <FormControlLabel
              label={valueToOption(row.isActive, options_state_setpoint).label}
              control={
                <Switch
                  checked={isActive}
                  onChange={(event, checked) => handleChangeStatus(checked, row)}
                  color="primary"
                ></Switch>
              }
            />
          )
        }
      }
    },
    {
      name: "cv_category",
      label: "CVカテゴリ",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: number) => {
          const option = valueToOptionNull(value, option_setpoint_cv_category)
          return (option ? option.label : "")
        }
      }
    },
    {
      name: "action_category",
      label: "アクションカテゴリ",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: number) => {
          const option = valueToOptionNull(value, option_setpoint_action_category)
          return (option ? option.label : "")
        }
      }
    },
    {
      name: "attribute",
      label: "計測手法",
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any) => {
          const attributeType = value ? value.attributeType : 0;
          return valueToOption(attributeType, option_setpoint_attribute_type).label;
        }
      }
    },
    {
      name: "",
      label: "詳細",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (idx: number) => {
          return (
            <KeyboardArrowRightIcon
              onClick={() => history.push(herasetpointdetail_path + setPoints[idx].ID)}
              className={classes.link}
              style={{cursor: "pointer"}}
            />
          );
        }
      },
    },
  ];

  const sortOrder: MUISortOptions = {
    name: "ID",
    direction: 'desc',
  }
  const selectableRows: SelectableRows = 'none';
  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.HERA_SET_POINTS) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: localStorage.getItem(STORAGE_KEY.HERA_SET_POINTS)
      ? JSON.parse(localStorage.getItem(STORAGE_KEY.HERA_SET_POINTS) ?? "")?.rowsPerPage
      : 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.HERA_SET_POINTS,
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  }

  return (
    <GenericTemplate title="">
      <React.Fragment>
        <Backdrop className={classes.backdrop2} open={progress}>
          <Bars color="#00BFFF" height={80} width={80}/>
        </Backdrop>
        <ApolloBreadcrumbs bread_no={53} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""}
                           platform={""}/>
        <CustomizedSnackbars/>
        <ApolloUserProfileAuth role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
          {trackerId &&
            <Tooltip title="測定ポイント新規登録" placement="bottom">
              <Link to={herasetpointedit_path + "0"} className={classes.link}>
                <Fab size="small" color="primary" aria-label="add" style={{marginTop: "10px"}}>
                  <AddIcon/>
                </Fab>
              </Link>
            </Tooltip>
          }
        </ApolloUserProfileAuth>
        <Card className={classes.root} square variant="outlined">
          <ApolloDataTable
            title=""
            data={setPoints ? setPoints : []}
            columns={columns}
            options={options}
          />
        </Card>
      </React.Fragment>

      <ActiveDialog
        open={open}
        type={"setpoint"}
        name={selectRow.current?.name ?? ""}
        handleSave={handleChangeStatusExecute}
        handleClose={() => {setOpen(false)}}
      />
    </GenericTemplate>
  );
};

export default HeraSetPointsPage;
